import { BACKEND_URL } from "@/config/runtime";

let pendingIds = new Set();
let flushTimer = null;

function flush() {
  if (pendingIds.size === 0) return;
  const ids = [...pendingIds];
  pendingIds.clear();
  flushTimer = null;

  // Fire individual requests using requestIdleCallback so they don't block scrolling
  const send = () => {
    ids.forEach(id => {
      fetch(`${BACKEND_URL}/api/listings/${id}/track-view`, {
        method: 'POST',
        credentials: 'include',
        keepalive: true,
      }).catch(() => {});
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(send, { timeout: 5000 });
  } else {
    setTimeout(send, 100);
  }
}

export function trackView(listingId) {
  pendingIds.add(listingId);
  if (!flushTimer) {
    flushTimer = setTimeout(flush, 2000);
  }
}
